import { aioRoutes } from './aio';
import { commonRoutes } from './common';
import { manageRoutes } from './manage';
import { purchaserRoutes } from './purchaser';
import { supplyRoutes } from './supply';

export const RouterName = {
  ...commonRoutes,
  ...aioRoutes,
  ...manageRoutes,
  ...supplyRoutes,
  ...purchaserRoutes,
};
